<template>
    <div class="JobViewLayoutMiddle">
        <OpportunityPageButtons
            v-if="org && job"
            :id="job.id"
            fixed-on-mobile
            :lang="job.lang"
            :org-name="org.title"
            :org-type="org.type"
            :preview="preview"
            :title="job.title"
            type="job"
        >
            <ApplyForJobButton
                :job="job"
                :org="org"
                :job-owner="isJobOwner"
                :preview="preview"
            />
        </OpportunityPageButtons>

        <!-- Depends on who is signed in, so it renders only in the browser -->
        <ClientOnly>
            <JobFitForCandidate v-if="job && !preview && !isJobOwner" :job="job" />
        </ClientOnly>

        <div v-if="job?.contentURL" class="my-8 aspect-video max-h-[400px] overflow-hidden rounded-lg">
            <CEmbedVideo :src="videoUrl" class="h-full w-full" />
        </div>
    </div>
</template>

<script setup lang="ts">
import { getEmbededVideo } from '#shared/media'
import type { Job } from '#shared/types/Job'
import type { Org } from '#shared/types/Org'
import JobFitForCandidate from '@/components/jobs/fit/JobFitForCandidate.vue'
import { useOrgs } from '@/composables/orgs/useOrgs'

interface Props {
    job?: Job
    org?: Org
    preview?: boolean
}

const props = defineProps<Props>()
const store = useApplicationStore()
const { getOrgFieldFunction } = useOrgs()

const isJobOwner = computed(() => {
    const userId = store.userId
    // Only show edit button if user is logged in AND is a member of the org
    if (!userId || !props.org?.memberIds) {
        return false
    }
    return props.org.memberIds.includes(userId)
})

const videoUrl = computed(() => {
    return props.job ? getEmbededVideo(props.job) : undefined
})
</script>
